import useIsSmall from "@/hooks/useIsSmall";
import { clubApi } from "@/services/axios";
import { Alert, Button, Modal, Skeleton, Text } from "@mantine/core";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useState } from "react";
import classes from "./messages.module.css";

type Recipient = { customerId: number; fullName: string; phoneNumber: string; message: string };
type Page = { result: Recipient[]; count: number };
const PAGE = 30;
const fa = (n: number) => n.toLocaleString("fa-IR");

// Who one send went to, with the text each person actually received (placeholders filled).
export default function Recipients({ id, onClose }: { id: number; onClose: () => void }) {
  const small = useIsSmall();
  const [openId, setOpenId] = useState<number | null>(null);
  const query = useInfiniteQuery({
    queryKey: ["sms-recipients", id],
    queryFn: async ({ pageParam = 0 }) =>
      (await clubApi.instance.get<Page>(`/api/Sms/SendRequest/${id}/Recipients`, { params: { Skip: pageParam, Count: PAGE } })).data,
    getNextPageParam: (last, pages) => (pages.length * PAGE < last.count ? pages.length * PAGE : undefined),
  });
  const rows = query.data?.pages.flatMap((p) => p.result) ?? [];
  const total = query.data?.pages[0]?.count ?? 0;

  return (
    <Modal opened onClose={onClose} title={total ? `گیرندگان (${fa(total)} نفر)` : "گیرندگان"} {...(small ? { fullScreen: true, radius: 0 } : { size: "lg", centered: true })}>
      {query.isLoading ? <Skeleton height={200} /> : query.isError ? (
        <Alert color="red">دریافت گیرندگان انجام نشد.<Button variant="subtle" onClick={() => query.refetch()}>تلاش دوباره</Button></Alert>
      ) : !rows.length ? (
        <Text size="sm" c="dimmed" ta="center" py="lg">فهرست گیرندگان برای این ارسال ثبت نشده است؛ پیامک‌های منطقه‌ای به شماره‌های منطقه می‌روند، نه مشتریان.</Text>
      ) : (
        <div className={classes.recipients}>
          {rows.map((r, i) => {
            const open = openId === i;
            return (
              <button key={`${r.customerId}-${i}`} type="button" className={classes.recipient} aria-expanded={open} onClick={() => setOpenId(open ? null : i)}>
                <span className={classes.recipientHead}><strong>{r.fullName || "بدون نام"}</strong><span dir="ltr">{r.phoneNumber}</span></span>
                {open && <span className={classes.recipientText}>{r.message}</span>}
              </button>
            );
          })}
          {query.hasNextPage && <Button variant="default" loading={query.isFetchingNextPage} onClick={() => query.fetchNextPage()}>نمایش بیشتر</Button>}
        </div>
      )}
    </Modal>
  );
}
